import Select from "@/components/Select";
import React, { useMemo } from "react";
import { SerializedCondition } from "../types";
import useConversationTags from "@/hooks/useConversationTags";
import useContactTags from "@/hooks/useContactTags";

export type TagCondition = {
  tagType: "conversation" | "contact";
  hasTag: boolean;
  tagId: number;
};

export function TagEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const tagCondition = JSON.parse(condition.data || "{}") as TagCondition;
  const { all: conversationTags, loading: conversationLoading } =
    useConversationTags();
  const { all: contactTags, loading: contactLoading } = useContactTags();

  const tagTypeOptions = {
    conversation: "Conversation",
    contact: "Contact"
  };

  const hasTagOptions = {
    true: "Has Tag",
    false: "Does Not Have Tag"
  };

  const tagOptions = useMemo(() => {
    const tags =
      tagCondition.tagType === "conversation" ? conversationTags : contactTags;
    return tags.reduce((acc, tag) => {
      acc[tag.id] = tag.name;
      return acc;
    }, {} as Record<number, string>);
  }, [tagCondition.tagType, conversationTags, contactTags]);

  function update(data: TagCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const isLoading =
    tagCondition.tagType === "conversation"
      ? conversationLoading
      : contactLoading;

  return (
    <>
      <Select
        options={tagTypeOptions}
        value={tagCondition.tagType || "conversation"}
        onChange={(v) =>
          update({
            ...tagCondition,
            tagType: v as "conversation" | "contact",
            tagId: 0
          })
        }
      />
      <Select
        options={hasTagOptions}
        value={String(tagCondition.hasTag !== false)}
        onChange={(v) => update({ ...tagCondition, hasTag: v === "true" })}
      />
      {!isLoading && (
        <Select
          options={tagOptions}
          value={tagCondition.tagId}
          onChange={(v) => update({ ...tagCondition, tagId: Number(v) })}
        />
      )}
    </>
  );
}
